/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../pages/__root'
import { Route as IndexRouteImport } from './../../pages/index'
import { Route as CallsRouteImport } from './../../pages/calls'
import { Route as CapacityRouteImport } from './../../pages/capacity'
import { Route as CellsRouteImport } from './../../pages/cells'
import { Route as DemoCallRouteImport } from './../../pages/demo-call'
import { Route as LoginRouteImport } from './../../pages/login'
import { Route as ScenariosRouteImport } from './../../pages/scenarios'
import { Route as SignalsRouteImport } from './../../pages/signals'
import { Route as UnitsRouteImport } from './../../pages/units'
import { Route as UsageRouteImport } from './../../pages/usage'
import { Route as VoicesRouteImport } from './../../pages/voices'
import { Route as CallsIndexRouteImport } from './../../pages/calls.index'
import { Route as CallsCallIdRouteImport } from './../../pages/calls.$callId'
import { Route as CapacityIndexRouteImport } from './../../pages/capacity.index'
import { Route as CapacityReservationIdRouteImport } from './../../pages/capacity.$reservationId'
import { Route as CellsIndexRouteImport } from './../../pages/cells.index'
import { Route as CellsCellIdRouteImport } from './../../pages/cells.$cellId'
import { Route as ScenariosIndexRouteImport } from './../../pages/scenarios.index'
import { Route as ScenariosScenarioIdRouteImport } from './../../pages/scenarios.$scenarioId'
import { Route as TelephonyAccountsRouteImport } from './../../pages/telephony.accounts'
import { Route as TelephonyLeasesRouteImport } from './../../pages/telephony.leases'
import { Route as TelephonyPoolsRouteImport } from './../../pages/telephony.pools'
import { Route as TelephonyProfilesRouteImport } from './../../pages/telephony.profiles'
import { Route as UnitsIndexRouteImport } from './../../pages/units.index'
import { Route as UnitsUnitIdRouteImport } from './../../pages/units.$unitId'
import { Route as VoicesIndexRouteImport } from './../../pages/voices.index'
import { Route as VoicesVoiceIdRouteImport } from './../../pages/voices.$voiceId'
import { Route as TelephonyAccountsIndexRouteImport } from './../../pages/telephony.accounts.index'
import { Route as TelephonyAccountsAccountIdRouteImport } from './../../pages/telephony.accounts.$accountId'
import { Route as TelephonyPoolsIndexRouteImport } from './../../pages/telephony.pools.index'
import { Route as TelephonyPoolsPoolIdRouteImport } from './../../pages/telephony.pools.$poolId'
import { Route as TelephonyProfilesIndexRouteImport } from './../../pages/telephony.profiles.index'
import { Route as TelephonyProfilesProfileIdRouteImport } from './../../pages/telephony.profiles.$profileId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CallsRoute = CallsRouteImport.update({
  id: '/calls',
  path: '/calls',
  getParentRoute: () => rootRouteImport,
} as any)
const CapacityRoute = CapacityRouteImport.update({
  id: '/capacity',
  path: '/capacity',
  getParentRoute: () => rootRouteImport,
} as any)
const CellsRoute = CellsRouteImport.update({
  id: '/cells',
  path: '/cells',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoCallRoute = DemoCallRouteImport.update({
  id: '/demo-call',
  path: '/demo-call',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ScenariosRoute = ScenariosRouteImport.update({
  id: '/scenarios',
  path: '/scenarios',
  getParentRoute: () => rootRouteImport,
} as any)
const SignalsRoute = SignalsRouteImport.update({
  id: '/signals',
  path: '/signals',
  getParentRoute: () => rootRouteImport,
} as any)
const UnitsRoute = UnitsRouteImport.update({
  id: '/units',
  path: '/units',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageRoute = UsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const VoicesRoute = VoicesRouteImport.update({
  id: '/voices',
  path: '/voices',
  getParentRoute: () => rootRouteImport,
} as any)
const CallsIndexRoute = CallsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CallsRoute,
} as any)
const CallsCallIdRoute = CallsCallIdRouteImport.update({
  id: '/$callId',
  path: '/$callId',
  getParentRoute: () => CallsRoute,
} as any)
const CapacityIndexRoute = CapacityIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CapacityRoute,
} as any)
const CapacityReservationIdRoute = CapacityReservationIdRouteImport.update({
  id: '/$reservationId',
  path: '/$reservationId',
  getParentRoute: () => CapacityRoute,
} as any)
const CellsIndexRoute = CellsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CellsRoute,
} as any)
const CellsCellIdRoute = CellsCellIdRouteImport.update({
  id: '/$cellId',
  path: '/$cellId',
  getParentRoute: () => CellsRoute,
} as any)
const ScenariosIndexRoute = ScenariosIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ScenariosRoute,
} as any)
const ScenariosScenarioIdRoute = ScenariosScenarioIdRouteImport.update({
  id: '/$scenarioId',
  path: '/$scenarioId',
  getParentRoute: () => ScenariosRoute,
} as any)
const TelephonyAccountsRoute = TelephonyAccountsRouteImport.update({
  id: '/telephony/accounts',
  path: '/telephony/accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const TelephonyLeasesRoute = TelephonyLeasesRouteImport.update({
  id: '/telephony/leases',
  path: '/telephony/leases',
  getParentRoute: () => rootRouteImport,
} as any)
const TelephonyPoolsRoute = TelephonyPoolsRouteImport.update({
  id: '/telephony/pools',
  path: '/telephony/pools',
  getParentRoute: () => rootRouteImport,
} as any)
const TelephonyProfilesRoute = TelephonyProfilesRouteImport.update({
  id: '/telephony/profiles',
  path: '/telephony/profiles',
  getParentRoute: () => rootRouteImport,
} as any)
const UnitsIndexRoute = UnitsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UnitsRoute,
} as any)
const UnitsUnitIdRoute = UnitsUnitIdRouteImport.update({
  id: '/$unitId',
  path: '/$unitId',
  getParentRoute: () => UnitsRoute,
} as any)
const VoicesIndexRoute = VoicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => VoicesRoute,
} as any)
const VoicesVoiceIdRoute = VoicesVoiceIdRouteImport.update({
  id: '/$voiceId',
  path: '/$voiceId',
  getParentRoute: () => VoicesRoute,
} as any)
const TelephonyAccountsIndexRoute = TelephonyAccountsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TelephonyAccountsRoute,
} as any)
const TelephonyAccountsAccountIdRoute =
  TelephonyAccountsAccountIdRouteImport.update({
    id: '/$accountId',
    path: '/$accountId',
    getParentRoute: () => TelephonyAccountsRoute,
  } as any)
const TelephonyPoolsIndexRoute = TelephonyPoolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TelephonyPoolsRoute,
} as any)
const TelephonyPoolsPoolIdRoute = TelephonyPoolsPoolIdRouteImport.update({
  id: '/$poolId',
  path: '/$poolId',
  getParentRoute: () => TelephonyPoolsRoute,
} as any)
const TelephonyProfilesIndexRoute = TelephonyProfilesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TelephonyProfilesRoute,
} as any)
const TelephonyProfilesProfileIdRoute =
  TelephonyProfilesProfileIdRouteImport.update({
    id: '/$profileId',
    path: '/$profileId',
    getParentRoute: () => TelephonyProfilesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/calls': typeof CallsRouteWithChildren
  '/capacity': typeof CapacityRouteWithChildren
  '/cells': typeof CellsRouteWithChildren
  '/demo-call': typeof DemoCallRoute
  '/login': typeof LoginRoute
  '/scenarios': typeof ScenariosRouteWithChildren
  '/signals': typeof SignalsRoute
  '/units': typeof UnitsRouteWithChildren
  '/usage': typeof UsageRoute
  '/voices': typeof VoicesRouteWithChildren
  '/calls/$callId': typeof CallsCallIdRoute
  '/capacity/$reservationId': typeof CapacityReservationIdRoute
  '/cells/$cellId': typeof CellsCellIdRoute
  '/scenarios/$scenarioId': typeof ScenariosScenarioIdRoute
  '/telephony/accounts': typeof TelephonyAccountsRouteWithChildren
  '/telephony/leases': typeof TelephonyLeasesRoute
  '/telephony/pools': typeof TelephonyPoolsRouteWithChildren
  '/telephony/profiles': typeof TelephonyProfilesRouteWithChildren
  '/units/$unitId': typeof UnitsUnitIdRoute
  '/voices/$voiceId': typeof VoicesVoiceIdRoute
  '/calls/': typeof CallsIndexRoute
  '/capacity/': typeof CapacityIndexRoute
  '/cells/': typeof CellsIndexRoute
  '/scenarios/': typeof ScenariosIndexRoute
  '/units/': typeof UnitsIndexRoute
  '/voices/': typeof VoicesIndexRoute
  '/telephony/accounts/$accountId': typeof TelephonyAccountsAccountIdRoute
  '/telephony/pools/$poolId': typeof TelephonyPoolsPoolIdRoute
  '/telephony/profiles/$profileId': typeof TelephonyProfilesProfileIdRoute
  '/telephony/accounts/': typeof TelephonyAccountsIndexRoute
  '/telephony/pools/': typeof TelephonyPoolsIndexRoute
  '/telephony/profiles/': typeof TelephonyProfilesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/demo-call': typeof DemoCallRoute
  '/login': typeof LoginRoute
  '/signals': typeof SignalsRoute
  '/usage': typeof UsageRoute
  '/calls/$callId': typeof CallsCallIdRoute
  '/capacity/$reservationId': typeof CapacityReservationIdRoute
  '/cells/$cellId': typeof CellsCellIdRoute
  '/scenarios/$scenarioId': typeof ScenariosScenarioIdRoute
  '/telephony/leases': typeof TelephonyLeasesRoute
  '/units/$unitId': typeof UnitsUnitIdRoute
  '/voices/$voiceId': typeof VoicesVoiceIdRoute
  '/calls': typeof CallsIndexRoute
  '/capacity': typeof CapacityIndexRoute
  '/cells': typeof CellsIndexRoute
  '/scenarios': typeof ScenariosIndexRoute
  '/units': typeof UnitsIndexRoute
  '/voices': typeof VoicesIndexRoute
  '/telephony/accounts/$accountId': typeof TelephonyAccountsAccountIdRoute
  '/telephony/pools/$poolId': typeof TelephonyPoolsPoolIdRoute
  '/telephony/profiles/$profileId': typeof TelephonyProfilesProfileIdRoute
  '/telephony/accounts': typeof TelephonyAccountsIndexRoute
  '/telephony/pools': typeof TelephonyPoolsIndexRoute
  '/telephony/profiles': typeof TelephonyProfilesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/calls': typeof CallsRouteWithChildren
  '/capacity': typeof CapacityRouteWithChildren
  '/cells': typeof CellsRouteWithChildren
  '/demo-call': typeof DemoCallRoute
  '/login': typeof LoginRoute
  '/scenarios': typeof ScenariosRouteWithChildren
  '/signals': typeof SignalsRoute
  '/units': typeof UnitsRouteWithChildren
  '/usage': typeof UsageRoute
  '/voices': typeof VoicesRouteWithChildren
  '/calls/$callId': typeof CallsCallIdRoute
  '/capacity/$reservationId': typeof CapacityReservationIdRoute
  '/cells/$cellId': typeof CellsCellIdRoute
  '/scenarios/$scenarioId': typeof ScenariosScenarioIdRoute
  '/telephony/accounts': typeof TelephonyAccountsRouteWithChildren
  '/telephony/leases': typeof TelephonyLeasesRoute
  '/telephony/pools': typeof TelephonyPoolsRouteWithChildren
  '/telephony/profiles': typeof TelephonyProfilesRouteWithChildren
  '/units/$unitId': typeof UnitsUnitIdRoute
  '/voices/$voiceId': typeof VoicesVoiceIdRoute
  '/calls/': typeof CallsIndexRoute
  '/capacity/': typeof CapacityIndexRoute
  '/cells/': typeof CellsIndexRoute
  '/scenarios/': typeof ScenariosIndexRoute
  '/units/': typeof UnitsIndexRoute
  '/voices/': typeof VoicesIndexRoute
  '/telephony/accounts/$accountId': typeof TelephonyAccountsAccountIdRoute
  '/telephony/pools/$poolId': typeof TelephonyPoolsPoolIdRoute
  '/telephony/profiles/$profileId': typeof TelephonyProfilesProfileIdRoute
  '/telephony/accounts/': typeof TelephonyAccountsIndexRoute
  '/telephony/pools/': typeof TelephonyPoolsIndexRoute
  '/telephony/profiles/': typeof TelephonyProfilesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/calls'
    | '/capacity'
    | '/cells'
    | '/demo-call'
    | '/login'
    | '/scenarios'
    | '/signals'
    | '/units'
    | '/usage'
    | '/voices'
    | '/calls/$callId'
    | '/capacity/$reservationId'
    | '/cells/$cellId'
    | '/scenarios/$scenarioId'
    | '/telephony/accounts'
    | '/telephony/leases'
    | '/telephony/pools'
    | '/telephony/profiles'
    | '/units/$unitId'
    | '/voices/$voiceId'
    | '/calls/'
    | '/capacity/'
    | '/cells/'
    | '/scenarios/'
    | '/units/'
    | '/voices/'
    | '/telephony/accounts/$accountId'
    | '/telephony/pools/$poolId'
    | '/telephony/profiles/$profileId'
    | '/telephony/accounts/'
    | '/telephony/pools/'
    | '/telephony/profiles/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/demo-call'
    | '/login'
    | '/signals'
    | '/usage'
    | '/calls/$callId'
    | '/capacity/$reservationId'
    | '/cells/$cellId'
    | '/scenarios/$scenarioId'
    | '/telephony/leases'
    | '/units/$unitId'
    | '/voices/$voiceId'
    | '/calls'
    | '/capacity'
    | '/cells'
    | '/scenarios'
    | '/units'
    | '/voices'
    | '/telephony/accounts/$accountId'
    | '/telephony/pools/$poolId'
    | '/telephony/profiles/$profileId'
    | '/telephony/accounts'
    | '/telephony/pools'
    | '/telephony/profiles'
  id:
    | '__root__'
    | '/'
    | '/calls'
    | '/capacity'
    | '/cells'
    | '/demo-call'
    | '/login'
    | '/scenarios'
    | '/signals'
    | '/units'
    | '/usage'
    | '/voices'
    | '/calls/$callId'
    | '/capacity/$reservationId'
    | '/cells/$cellId'
    | '/scenarios/$scenarioId'
    | '/telephony/accounts'
    | '/telephony/leases'
    | '/telephony/pools'
    | '/telephony/profiles'
    | '/units/$unitId'
    | '/voices/$voiceId'
    | '/calls/'
    | '/capacity/'
    | '/cells/'
    | '/scenarios/'
    | '/units/'
    | '/voices/'
    | '/telephony/accounts/$accountId'
    | '/telephony/pools/$poolId'
    | '/telephony/profiles/$profileId'
    | '/telephony/accounts/'
    | '/telephony/pools/'
    | '/telephony/profiles/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CallsRoute: typeof CallsRouteWithChildren
  CapacityRoute: typeof CapacityRouteWithChildren
  CellsRoute: typeof CellsRouteWithChildren
  DemoCallRoute: typeof DemoCallRoute
  LoginRoute: typeof LoginRoute
  ScenariosRoute: typeof ScenariosRouteWithChildren
  SignalsRoute: typeof SignalsRoute
  UnitsRoute: typeof UnitsRouteWithChildren
  UsageRoute: typeof UsageRoute
  VoicesRoute: typeof VoicesRouteWithChildren
  TelephonyAccountsRoute: typeof TelephonyAccountsRouteWithChildren
  TelephonyLeasesRoute: typeof TelephonyLeasesRoute
  TelephonyPoolsRoute: typeof TelephonyPoolsRouteWithChildren
  TelephonyProfilesRoute: typeof TelephonyProfilesRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calls': {
      id: '/calls'
      path: '/calls'
      fullPath: '/calls'
      preLoaderRoute: typeof CallsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/capacity': {
      id: '/capacity'
      path: '/capacity'
      fullPath: '/capacity'
      preLoaderRoute: typeof CapacityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cells': {
      id: '/cells'
      path: '/cells'
      fullPath: '/cells'
      preLoaderRoute: typeof CellsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo-call': {
      id: '/demo-call'
      path: '/demo-call'
      fullPath: '/demo-call'
      preLoaderRoute: typeof DemoCallRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scenarios': {
      id: '/scenarios'
      path: '/scenarios'
      fullPath: '/scenarios'
      preLoaderRoute: typeof ScenariosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signals': {
      id: '/signals'
      path: '/signals'
      fullPath: '/signals'
      preLoaderRoute: typeof SignalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/units': {
      id: '/units'
      path: '/units'
      fullPath: '/units'
      preLoaderRoute: typeof UnitsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage': {
      id: '/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/voices': {
      id: '/voices'
      path: '/voices'
      fullPath: '/voices'
      preLoaderRoute: typeof VoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calls/': {
      id: '/calls/'
      path: '/'
      fullPath: '/calls/'
      preLoaderRoute: typeof CallsIndexRouteImport
      parentRoute: typeof CallsRoute
    }
    '/calls/$callId': {
      id: '/calls/$callId'
      path: '/$callId'
      fullPath: '/calls/$callId'
      preLoaderRoute: typeof CallsCallIdRouteImport
      parentRoute: typeof CallsRoute
    }
    '/capacity/': {
      id: '/capacity/'
      path: '/'
      fullPath: '/capacity/'
      preLoaderRoute: typeof CapacityIndexRouteImport
      parentRoute: typeof CapacityRoute
    }
    '/capacity/$reservationId': {
      id: '/capacity/$reservationId'
      path: '/$reservationId'
      fullPath: '/capacity/$reservationId'
      preLoaderRoute: typeof CapacityReservationIdRouteImport
      parentRoute: typeof CapacityRoute
    }
    '/cells/': {
      id: '/cells/'
      path: '/'
      fullPath: '/cells/'
      preLoaderRoute: typeof CellsIndexRouteImport
      parentRoute: typeof CellsRoute
    }
    '/cells/$cellId': {
      id: '/cells/$cellId'
      path: '/$cellId'
      fullPath: '/cells/$cellId'
      preLoaderRoute: typeof CellsCellIdRouteImport
      parentRoute: typeof CellsRoute
    }
    '/scenarios/': {
      id: '/scenarios/'
      path: '/'
      fullPath: '/scenarios/'
      preLoaderRoute: typeof ScenariosIndexRouteImport
      parentRoute: typeof ScenariosRoute
    }
    '/scenarios/$scenarioId': {
      id: '/scenarios/$scenarioId'
      path: '/$scenarioId'
      fullPath: '/scenarios/$scenarioId'
      preLoaderRoute: typeof ScenariosScenarioIdRouteImport
      parentRoute: typeof ScenariosRoute
    }
    '/telephony/accounts': {
      id: '/telephony/accounts'
      path: '/telephony/accounts'
      fullPath: '/telephony/accounts'
      preLoaderRoute: typeof TelephonyAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telephony/leases': {
      id: '/telephony/leases'
      path: '/telephony/leases'
      fullPath: '/telephony/leases'
      preLoaderRoute: typeof TelephonyLeasesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telephony/pools': {
      id: '/telephony/pools'
      path: '/telephony/pools'
      fullPath: '/telephony/pools'
      preLoaderRoute: typeof TelephonyPoolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telephony/profiles': {
      id: '/telephony/profiles'
      path: '/telephony/profiles'
      fullPath: '/telephony/profiles'
      preLoaderRoute: typeof TelephonyProfilesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/units/': {
      id: '/units/'
      path: '/'
      fullPath: '/units/'
      preLoaderRoute: typeof UnitsIndexRouteImport
      parentRoute: typeof UnitsRoute
    }
    '/units/$unitId': {
      id: '/units/$unitId'
      path: '/$unitId'
      fullPath: '/units/$unitId'
      preLoaderRoute: typeof UnitsUnitIdRouteImport
      parentRoute: typeof UnitsRoute
    }
    '/voices/': {
      id: '/voices/'
      path: '/'
      fullPath: '/voices/'
      preLoaderRoute: typeof VoicesIndexRouteImport
      parentRoute: typeof VoicesRoute
    }
    '/voices/$voiceId': {
      id: '/voices/$voiceId'
      path: '/$voiceId'
      fullPath: '/voices/$voiceId'
      preLoaderRoute: typeof VoicesVoiceIdRouteImport
      parentRoute: typeof VoicesRoute
    }
    '/telephony/accounts/': {
      id: '/telephony/accounts/'
      path: '/'
      fullPath: '/telephony/accounts/'
      preLoaderRoute: typeof TelephonyAccountsIndexRouteImport
      parentRoute: typeof TelephonyAccountsRoute
    }
    '/telephony/accounts/$accountId': {
      id: '/telephony/accounts/$accountId'
      path: '/$accountId'
      fullPath: '/telephony/accounts/$accountId'
      preLoaderRoute: typeof TelephonyAccountsAccountIdRouteImport
      parentRoute: typeof TelephonyAccountsRoute
    }
    '/telephony/pools/': {
      id: '/telephony/pools/'
      path: '/'
      fullPath: '/telephony/pools/'
      preLoaderRoute: typeof TelephonyPoolsIndexRouteImport
      parentRoute: typeof TelephonyPoolsRoute
    }
    '/telephony/pools/$poolId': {
      id: '/telephony/pools/$poolId'
      path: '/$poolId'
      fullPath: '/telephony/pools/$poolId'
      preLoaderRoute: typeof TelephonyPoolsPoolIdRouteImport
      parentRoute: typeof TelephonyPoolsRoute
    }
    '/telephony/profiles/': {
      id: '/telephony/profiles/'
      path: '/'
      fullPath: '/telephony/profiles/'
      preLoaderRoute: typeof TelephonyProfilesIndexRouteImport
      parentRoute: typeof TelephonyProfilesRoute
    }
    '/telephony/profiles/$profileId': {
      id: '/telephony/profiles/$profileId'
      path: '/$profileId'
      fullPath: '/telephony/profiles/$profileId'
      preLoaderRoute: typeof TelephonyProfilesProfileIdRouteImport
      parentRoute: typeof TelephonyProfilesRoute
    }
  }
}

interface CallsRouteChildren {
  CallsCallIdRoute: typeof CallsCallIdRoute
  CallsIndexRoute: typeof CallsIndexRoute
}

const CallsRouteChildren: CallsRouteChildren = {
  CallsCallIdRoute: CallsCallIdRoute,
  CallsIndexRoute: CallsIndexRoute,
}

const CallsRouteWithChildren = CallsRoute._addFileChildren(CallsRouteChildren)

interface CapacityRouteChildren {
  CapacityReservationIdRoute: typeof CapacityReservationIdRoute
  CapacityIndexRoute: typeof CapacityIndexRoute
}

const CapacityRouteChildren: CapacityRouteChildren = {
  CapacityReservationIdRoute: CapacityReservationIdRoute,
  CapacityIndexRoute: CapacityIndexRoute,
}

const CapacityRouteWithChildren = CapacityRoute._addFileChildren(
  CapacityRouteChildren,
)

interface CellsRouteChildren {
  CellsCellIdRoute: typeof CellsCellIdRoute
  CellsIndexRoute: typeof CellsIndexRoute
}

const CellsRouteChildren: CellsRouteChildren = {
  CellsCellIdRoute: CellsCellIdRoute,
  CellsIndexRoute: CellsIndexRoute,
}

const CellsRouteWithChildren = CellsRoute._addFileChildren(CellsRouteChildren)

interface ScenariosRouteChildren {
  ScenariosScenarioIdRoute: typeof ScenariosScenarioIdRoute
  ScenariosIndexRoute: typeof ScenariosIndexRoute
}

const ScenariosRouteChildren: ScenariosRouteChildren = {
  ScenariosScenarioIdRoute: ScenariosScenarioIdRoute,
  ScenariosIndexRoute: ScenariosIndexRoute,
}

const ScenariosRouteWithChildren = ScenariosRoute._addFileChildren(
  ScenariosRouteChildren,
)

interface UnitsRouteChildren {
  UnitsUnitIdRoute: typeof UnitsUnitIdRoute
  UnitsIndexRoute: typeof UnitsIndexRoute
}

const UnitsRouteChildren: UnitsRouteChildren = {
  UnitsUnitIdRoute: UnitsUnitIdRoute,
  UnitsIndexRoute: UnitsIndexRoute,
}

const UnitsRouteWithChildren = UnitsRoute._addFileChildren(UnitsRouteChildren)

interface VoicesRouteChildren {
  VoicesVoiceIdRoute: typeof VoicesVoiceIdRoute
  VoicesIndexRoute: typeof VoicesIndexRoute
}

const VoicesRouteChildren: VoicesRouteChildren = {
  VoicesVoiceIdRoute: VoicesVoiceIdRoute,
  VoicesIndexRoute: VoicesIndexRoute,
}

const VoicesRouteWithChildren =
  VoicesRoute._addFileChildren(VoicesRouteChildren)

interface TelephonyAccountsRouteChildren {
  TelephonyAccountsAccountIdRoute: typeof TelephonyAccountsAccountIdRoute
  TelephonyAccountsIndexRoute: typeof TelephonyAccountsIndexRoute
}

const TelephonyAccountsRouteChildren: TelephonyAccountsRouteChildren = {
  TelephonyAccountsAccountIdRoute: TelephonyAccountsAccountIdRoute,
  TelephonyAccountsIndexRoute: TelephonyAccountsIndexRoute,
}

const TelephonyAccountsRouteWithChildren =
  TelephonyAccountsRoute._addFileChildren(TelephonyAccountsRouteChildren)

interface TelephonyPoolsRouteChildren {
  TelephonyPoolsPoolIdRoute: typeof TelephonyPoolsPoolIdRoute
  TelephonyPoolsIndexRoute: typeof TelephonyPoolsIndexRoute
}

const TelephonyPoolsRouteChildren: TelephonyPoolsRouteChildren = {
  TelephonyPoolsPoolIdRoute: TelephonyPoolsPoolIdRoute,
  TelephonyPoolsIndexRoute: TelephonyPoolsIndexRoute,
}

const TelephonyPoolsRouteWithChildren = TelephonyPoolsRoute._addFileChildren(
  TelephonyPoolsRouteChildren,
)

interface TelephonyProfilesRouteChildren {
  TelephonyProfilesProfileIdRoute: typeof TelephonyProfilesProfileIdRoute
  TelephonyProfilesIndexRoute: typeof TelephonyProfilesIndexRoute
}

const TelephonyProfilesRouteChildren: TelephonyProfilesRouteChildren = {
  TelephonyProfilesProfileIdRoute: TelephonyProfilesProfileIdRoute,
  TelephonyProfilesIndexRoute: TelephonyProfilesIndexRoute,
}

const TelephonyProfilesRouteWithChildren =
  TelephonyProfilesRoute._addFileChildren(TelephonyProfilesRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CallsRoute: CallsRouteWithChildren,
  CapacityRoute: CapacityRouteWithChildren,
  CellsRoute: CellsRouteWithChildren,
  DemoCallRoute: DemoCallRoute,
  LoginRoute: LoginRoute,
  ScenariosRoute: ScenariosRouteWithChildren,
  SignalsRoute: SignalsRoute,
  UnitsRoute: UnitsRouteWithChildren,
  UsageRoute: UsageRoute,
  VoicesRoute: VoicesRouteWithChildren,
  TelephonyAccountsRoute: TelephonyAccountsRouteWithChildren,
  TelephonyLeasesRoute: TelephonyLeasesRoute,
  TelephonyPoolsRoute: TelephonyPoolsRouteWithChildren,
  TelephonyProfilesRoute: TelephonyProfilesRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
